/* eslint-env browser */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'redux-router';

import { setHeader, loadPageList, setPageListSearch } from 'actions';

import isEmpty from 'lodash/isEmpty';
import has from 'lodash/has';

import Loading from 'components/common/Loading';
import Icon from 'components/common/Icon';
import DebounceInput from 'components/common/DebounceInput';
import PageList from 'components/calendar/PageList';
import PageListItem from 'components/calendar/PageListItem';

class PageListPage extends Component {
  constructor(props) {
    // console.log('PageListPage constructor() - start');
    super(props);

    this.state = {
      showSearch: !!props.search || false,
      searchTerm: props.search || '',
    };

    this.getTitle = this.getTitle.bind(this);
    this.toggleSearch = this.toggleSearch.bind(this);
    this.updateSearch = this.updateSearch.bind(this);
    this.renderPageListItem = this.renderPageListItem.bind(this);

    // console.log('PageListPage constructor() - end');
  }

  componentWillMount() {
    // console.log('PageListPage componentWillMount() - start');
    const { search } = this.props;
    this.props.loadPageList(search);
    this.updateHeader(this.props);
    // console.log('PageListPage componentWillMount() - end');
  }

  componentWillReceiveProps(nextProps) {
    // console.log('PageListPage componentWillReceiveProps() - start');
    // console.log(this.props.search);
    // console.log(nextProps.search);
    if (!isEmpty(this.props.search) && isEmpty(nextProps.search)) {
      // this.updateSearch('');
    }
    
    if (this.props.search !== nextProps.search) {
      // nextProps.loadPageList(nextProps.search);
    }

    // if (isEmpty(this.props.search) !== isEmpty(nextProps.search)) {
    //   this.updateHeader(nextProps);
    // }

    // console.log('PageListPage componentWillReceiveProps() - end');
  }

  componentDidUpdate() {
  }

  getTitle() {
    if (has(window.CONFIG, 'enable_reports') && has(window.CONFIG, 'rename_schedules_to_reports')) {
      if (window.CONFIG.enable_reports === '1' && window.CONFIG.rename_schedules_to_reports === '2') {
        return 'Page';
      } else if (window.CONFIG.enable_reports === '1' && window.CONFIG.rename_schedules_to_reports === '1') {
        return 'Report';
      } else if (window.CONFIG.enable_reports === '1') {
        return 'Schedule';
      }
    }

    return 'Report';
  }

  toggleSearch() {
    // console.log('PageListPage +toggleSearch() - start');
    const prevSearchTerm = this.state.searchTerm;
    // console.log(prevSearchTerm);
    this.setState({ showSearch: !this.state.showSearch, searchTerm: '' }, () => {
      // console.log('PageListPage +toggleSearch() ->setState - start');
      // console.log(prevSearchTerm);
      if(prevSearchTerm != '') {
        // this.props.setPageListSearch(this.state.searchTerm);
        this.props.loadPageList(this.state.searchTerm);
      }
      this.updateHeader(this.props);
      // console.log('PageListPage +toggleSearch() ->setState - end');
    });
    // console.log('PageListPage +toggleSearch() - end');
  }

  updateSearch(search) {
    // console.log('PageListPage +updateSearch() - start');
    const prevSearchTerm = this.state.searchTerm;
    this.setState({ searchTerm: search }, () => {
      // console.log('PageListPage +updateSearch() ->setState - start');
      // if(search != prevSearchTerm) {
      //   // this.props.setPageListSearch(search);
      //   this.props.loadPageList(search);
      // }
      // console.log('PageListPage +updateSearch() ->setState - end');
    });

    if(search != prevSearchTerm) {
      // this.props.setPageListSearch(search);
      this.props.loadPageList(search);
    }
    // console.log('PageListPage +updateSearch() - end');
  }

  updateHeader(props) {
    // console.log('PageListPage +updateHeader() - start');
    // console.log(this.state.showSearch);

    const showBack = false;
    const backTitle = '';

    const searchIcon = this.state.showSearch
      ? (<a className="clickable" onClick={() => this.toggleSearch()}>Cancel</a>)
      : (<Icon icon="search" size="medium" clickable onClick={() => this.toggleSearch()} />);

    const headerTitle = this.getTitle() + 's';

    this.props.setHeader(headerTitle, showBack, backTitle, searchIcon);

    // console.log('PageListPage +updateHeader() - end');
  }

  renderPageListItem(page, drawDivider = false) {
    let onSelect;
    if(page.id == '-3') {
      onSelect = (selectedPage) => { this.props.push(`/calendar/year/`) };
    } else {
      onSelect = (selectedPage) => { this.props.push(`/page/view/${selectedPage.id}`) };
    }
    return (
      <PageListItem
        drawDivider={drawDivider}
        showChevron
        page={page}
        key={`${page.id}`}
        onSelect={onSelect}
      />
   );
  }

  render() {
    // console.log('PageListPage render()');
    if (this.props.isLoading) {
      return (
        <Loading withWrapper />
      );
    }

    const pageTitle = this.getTitle() + 's';
    const searchTitle = "Search " + pageTitle;

    return (
      <section className="page-page">
        {(this.state.showSearch) && (
          <div style={{ padding: 10, paddingBottom: 0 }}>
            <div className="input-group search-box">
              <DebounceInput
                label={searchTitle}
                type="search"
                minLength={2}
                debounceTimeout={300}
                autoFocus
                initialValue={this.state.searchTerm}
                onChange={event => this.updateSearch(event.target.value) }
              />
            </div>
          </div>
        )}
        <PageList
          pages={this.props.pages}
          isLoading={this.props.isLoading}
          renderItem={this.renderPageListItem}
        />
      </section>
    );
  }
}

function mapStateToProps(state) {
  // console.log('PageListPage mapStateToProps()');
  const { search } = state.router.location.query;
  const { page } = state;
  const { pages, isLoading } = page;

  return {
    isLoading,
    pages,
    search: page.search || search,
  };
}

export default connect(mapStateToProps, {
  setHeader,
  loadPageList,
  setPageListSearch,
  push,
})(PageListPage);



// WEBPACK FOOTER //
// ./src/app/containers/PageListPage.js